module.exports = __webpack_public_path__ + "media/images/product_no_image-df1aa4dd13abb766784b8588b124dc36.png";